import appointmentsReducer from './appointments/appointmentsSlice';
import healthProfileReducer from './healthProfile/healthProfileSlice';
import joinReducer from './join/joinSlice';
import labTestsReducer from './labTests/labTestsSlice';
import mifReducer from './mif/mifSlice';
import modalReducer from './modals/modalSlice';
import notificationsReducer from './notifications/notificationsSlice';
import orchestrateReducer from './orchestrate-signup/orchestrateSlice';
import programsCatalogReducer from './programs/programsCatalogSlice';
import programsReducer from './programs/programsSlice';
import providerReducer from './provider/providerSlice';
import renewalReducer from './renewal/renewalSlice';
import settingsReducer from './settings/settingsSlice';
import shopReducer from './shop/shopSlice';
import signupReducer from './signup/signupSlice';
import userReducer from './user/userSlice';
import wmReducer from './wm/wmSlice';

export const sliceReducers = {
  appointments: appointmentsReducer,
  healthProfile: healthProfileReducer,
  join: joinReducer,
  labTests: labTestsReducer,
  mif: mifReducer,
  modals: modalReducer,
  notifications: notificationsReducer,
  orchestrate: orchestrateReducer,
  programs: programsReducer,
  programsCatalog: programsCatalogReducer,
  provider: providerReducer,
  renewal: renewalReducer,
  settings: settingsReducer,
  shop: shopReducer,
  signUp: signupReducer,
  user: userReducer,
  wm: wmReducer
};
